import { render, staticRenderFns } from "./TaskTypeList.vue?vue&type=template&id=5f8b24d7&scoped=true&"
import script from "./TaskTypeList.vue?vue&type=script&lang=js&"
export * from "./TaskTypeList.vue?vue&type=script&lang=js&"
import style0 from "./TaskTypeList.vue?vue&type=style&index=0&id=5f8b24d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8b24d7",
  null
  
)

export default component.exports